import auth from "@/services/auth";

export default async () => {
  const jwtToken = await auth.getSessionIdToken();

  const headers = {
    "content-type": "application/json",
  };

  if (!jwtToken) {
    return { headers };
  }

  return {
    headers: {
      ...headers,
      Authorization: `Bearer ${jwtToken}`,
    },
  };
};
